var map = {
	"./goldcoin/task-detail-step-3.jpg": 58960,
	"./memetown/task-detail-step-3.jpg": 45396,
	"./reflection/task-detail-step-3.jpg": 27475,
	"./tapcoin/task-detail-step-3.jpg": 4134
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76444;